/*

import { useEffect, useState } from "react";
import api from "../services/api";

console.log("baseURL =", api.defaults.baseURL);

export default function SupportPage() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  /*const fetchMessages = async () => {
    try {
      const res = await api.get("/messages");
      console.log("MESSAGES =>", res.data);

      setMessages(res.data);
      


    } catch (err) {
      console.error(err);
      setError(
        `Erreur ${err.response?.status ?? "réseau"} — ${
          err.response?.data?.message ?? "Impossible de charger les messages"
        }`
      );
    } finally {
      setLoading(false); // ✅ toujours appelé, succès ou erreur
    }
  };


  const fetchMessages = async () => {
  try {
    console.log("URL =", api.defaults.baseURL + "/support/messages");
    const res = await api.get("/support/messages");
    setMessages(res.data);
  } catch (err) {
    console.log("ERREUR URL =", err.config?.url);
    console.log("ERREUR STATUS =", err.response?.status);
    setError("Erreur " + err.response?.status);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchMessages();
  }, []);

  return (
    <div>
      <h1 style={{ color: "#0B3C5D", marginBottom: 30 }}>
        🎧 Support Clients
      </h1>

      {loading && <p>Chargement...</p>}

      {!loading && error && (
        <p style={{ color: "red" }}>{error}</p>
      )}

      {!loading && !error && messages.length === 0 && (
        <p>Aucun message trouvé.</p>
      )}

      {!loading &&
        !error &&
        messages.map((m) => (
          <div key={m.id} style={card}>
            <h3>📞 {m.telephone}</h3>
            <p style={{ marginTop: 10, marginBottom: 10 }}>{m.message}</p>
            <small>{new Date(m.created_at).toLocaleString()}</small>
          </div>
        ))}
    </div>
  );
}

const card = {
  background: "#fff",
  padding: 20,
  marginBottom: 20,
  borderRadius: 12,
  boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
  borderLeft: "6px solid #FFA500",
};*/

import { useEffect, useState } from "react";
import api from "../services/api";

export default function SupportPage() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState("tous");

  useEffect(() => {
    api.get("/support/messages")
      .then(res => setMessages(res.data))
      .catch(err => setError(`Erreur ${err.response?.status ?? "réseau"}`))
      .finally(() => setLoading(false));
  }, []);

  const filtered = messages.filter(m => {
    if (filter === "nonlus") return m.status === "unread";
    if (filter === "lus") return m.status !== "unread";
    return true;
  });

  const initials = (phone) => phone?.slice(-4, -2).toUpperCase() || "??";

  if (loading) return <p style={{ padding: 20 }}>Chargement...</p>;
  if (error)   return <p style={{ padding: 20, color: "red" }}>{error}</p>;

  return (
    <div style={{ padding: "1.5rem 0" }}>

      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "2rem" }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 500, color: "#0B3C5D" }}>
            🎧 Support clients
          </h1>
          <p style={{ fontSize: 14, color: "#888", marginTop: 4 }}>Gestion des messages entrants</p>
        </div>
        <div style={{ fontSize: 12, padding: "4px 12px", borderRadius: 20, background: "#FAEEDA", color: "#854F0B", border: "0.5px solid #FAC775" }}>
          ✉️ {messages.length} messages
        </div>
      </div>

      {/* Filtres */}
      <div style={{ display: "flex", gap: 8, marginBottom: "1.5rem" }}>
        {[["tous", "Tous"], ["nonlus", "Non lus"], ["lus", "Lus"]].map(([val, label]) => (
          <button key={val} onClick={() => setFilter(val)} style={{
            fontSize: 13, padding: "6px 14px", borderRadius: 20, cursor: "pointer",
            border: "0.5px solid #ccc",
            background: filter === val ? "#0B3C5D" : "#fff",
            color: filter === val ? "#fff" : "#888",
          }}>
            {label}
          </button>
        ))}
      </div>

      {/* Liste */}
      {filtered.length === 0 && <p style={{ color: "#888" }}>Aucun message trouvé.</p>}

      {filtered.map(m => (
        <div key={m.id} style={{
          background: "#fff",
          border: "0.5px solid #e5e5e5",
          borderRadius: 12,
          padding: "1.25rem",
          marginBottom: 12,
          borderLeft: `4px solid ${m.status === "unread" ? "#FFA500" : "#e5e5e5"}`,
          display: "flex",
          gap: 14,
        }}>
          <div style={{
            width: 40, height: 40, borderRadius: "50%", flexShrink: 0,
            background: "#FAEEDA", color: "#854F0B",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 13, fontWeight: 500,
          }}>
            {initials(m.telephone)}
          </div>

          <div style={{ flex: 1 }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
              <span style={{ fontSize: 14, fontWeight: 500, color: "#0B3C5D" }}>
                📞 {m.telephone}
              </span>
              <span style={{ fontSize: 12, color: "#aaa" }}>
                {new Date(m.created_at).toLocaleString("fr-FR")}
              </span>
            </div>

            <p style={{ fontSize: 14, color: "#555", lineHeight: 1.6, marginBottom: 10 }}>
              {m.message}
            </p>

            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{
                fontSize: 11, padding: "2px 10px", borderRadius: 20,
                background: m.status === "unread" ? "#FAEEDA" : "#f0f0f0",
                color: m.status === "unread" ? "#854F0B" : "#888",
              }}>
                {m.status === "unread" ? "Non lu" : "Lu"}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}